module.exports = __webpack_public_path__ + "static/media/comminication-freelancer-hero-image.bbf2d70c.webp";